var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "error" } }, [
    _vm.isDC
      ? _c("main", [
          _vm._v("\n    本システムはお使いのブラウザではご利用できません。"),
          _c("br"),
          _vm._v(
            "\n    お手数ですが、Chrome、Safari、Edgeのいずれかの最新バージョンをお使いください。\n  "
          )
        ])
      : _c("main", [
          _vm._v("\n    本システムはお使いのブラウザではご利用できません。"),
          _c("br"),
          _vm._v(
            "\n    お手数ですが、Chromeの最新バージョンをお使いください。"
          ),
          _c("br"),
          _c("br"),
          _vm._v("\n    Chromeは"),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.google.com/chrome/",
                target: "_blank"
              }
            },
            [_vm._v("こちら")]
          ),
          _vm._v("からダウンロードいただけます。\n  ")
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1523b9b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1523b9b1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/common/UnSupported.vue
// module id = null
// module chunks = 